export const rxInterceptWasteByDateRange = {amountOfWaste: Math.floor(Math.random() * (6 - 4 + 1) + 4)};
